const calcFutureConcern = (data) => {

    let minCriteria, maxCriteria

    let minForecast = parseFloat(Math.min(data.forecastLow, data.forecastHigh));
    let maxForecast = parseFloat(Math.max(data.forecastLow, data.forecastHigh));

    // if vertical, use SLR to calculate future concern
    if (data.type === 'vertical') {
        // console.log('calc future concern test',data)
        minCriteria = parseFloat(Math.min(data.slrLow, data.slrHigh));
        maxCriteria = parseFloat(Math.max(data.slrLow, data.slrHigh));
    } else {
        // otherwise calculate as usual
        minCriteria = parseFloat(Math.min(data.criteriaLow, data.criteriaHigh));
        maxCriteria = parseFloat(Math.max(data.criteriaLow, data.criteriaHigh));
    }

    // if there is missing data, not enough info for future concern
    if (data.trajectLow === '' || data.trajectHigh === '' || data.forecastLow === '' || data.forecastHigh === '' || data.forecastYears === '') {
        data.futureConcern = -1
    }
    // if values fall outside criteria range
    else if (minForecast < minCriteria || maxForecast > maxCriteria) {
        data.futureConcern = 1;
    }
    // if values fall within criteria range
    else {
        data.futureConcern = 0;
    }

    return data.futureConcern
}

export default calcFutureConcern
